import { useEffect, useState } from "react";
import axiosInstance from "../api/axios";

const useCountry = (controller, scope) => {
  const [country, setCountry] = useState({});
  const getCountry = async (controller, customerScope) => {
    const response = await axiosInstance.get(
      `/get_country/details/${controller}/${customerScope?.toLowerCase()}`
    );
    if (response?.data?.countryDetailsVO[0]?.country) {
      const { country, countryCode } = response?.data?.countryDetailsVO[0];
      setCountry({
        value: countryCode,
        label: country,
      });
    }
  };
  useEffect(() => {
    if (controller && scope) {
      getCountry(controller, scope);
    }
  }, [controller, scope]);

  return { country, getCountry };
};

export default useCountry;
